// Auto-generated OpenAPI specification
// Generated on: 2026-03-19T06:38:16.299Z
// Do not edit manually - this file is auto-generated

export const openApiSpec = {
  "openapi": "3.0.3",
  "info": {
    "title": "AI RAG API",
    "description": "AI-powered Retrieval-Augmented Generation (RAG) system API for document processing, chat, and knowledge retrieval",
    "version": "1.0.0"
  },
  "servers": [
    {
      "url": "http://localhost:3000/api",
      "description": "Development server"
    },
    {
      "url": "https://your-domain.com/api",
      "description": "Production server"
    }
  ],
  "paths": {
    "/retrieval": {
      "post": {
        "summary": "POST /retrieval",
        "tags": [
          "Retrieval"
        ],
        "parameters": [],
        "responses": {
          "200": {
            "description": "Successful operation",
            "content": {
              "application/json": {
                "schema": {
                  "type": "object"
                }
              }
            }
          },
          "400": {
            "description": "Bad request",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/Error"
                }
              }
            }
          },
          "500": {
            "description": "Internal server error",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/Error"
                }
              }
            }
          }
        }
      }
    },
    "/webpages": {
      "post": {
        "summary": "POST /webpages",
        "tags": [
          "Webpages"
        ],
        "parameters": [],
        "responses": {
          "200": {
            "description": "Successful operation",
            "content": {
              "application/json": {
                "schema": {
                  "type": "object"
                }
              }
            }
          },
          "400": {
            "description": "Bad request",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/Error"
                }
              }
            }
          },
          "500": {
            "description": "Internal server error",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/Error"
                }
              }
            }
          }
        }
      }
    },
    "/postman": {
      "post": {
        "summary": "POST /postman",
        "tags": [
          "Postman"
        ],
        "parameters": [],
        "responses": {
          "200": {
            "description": "Successful operation",
            "content": {
              "application/json": {
                "schema": {
                  "type": "object"
                }
              }
            }
          },
          "400": {
            "description": "Bad request",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/Error"
                }
              }
            }
          },
          "500": {
            "description": "Internal server error",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/Error"
                }
              }
            }
          }
        }
      }
    },
    "/openapi": {
      "post": {
        "summary": "POST /openapi",
        "tags": [
          "Openapi"
        ],
        "parameters": [],
        "responses": {}
      }
    },
    "/files": {
      "post": {
        "summary": "Upload and process a file",
        "description": "Upload a file (supports PDF and Markdown) for processing and chunking. Returns a job ID for tracking progress.",
        "tags": [
          "Files"
        ],
        "parameters": [
          {
            "name": "filename",
            "schema": {
              "type": "string"
            },
            "description": "- Name of the file being uploaded (supports .pdf, .md, .markdown extensions)"
          },
          {
            "name": "access_level",
            "schema": {
              "type": "string"
            },
            "description": "- Access level for the document (public, private, restricted)"
          },
          {
            "name": "org_id",
            "schema": {
              "type": "string"
            },
            "description": "- Organization identifier"
          },
          {
            "name": "user_id",
            "schema": {
              "type": "string"
            },
            "description": "- User identifier"
          },
          {
            "name": "connector",
            "schema": {
              "type": "string"
            },
            "description": "- Source connector type (default: file-upload)"
          },
          {
            "name": "webhook_url",
            "schema": {
              "type": "string"
            },
            "description": "- Optional webhook URL for job completion notification"
          }
        ],
        "requestBody": {
          "required": true,
          "content": {
            "application/json": {
              "schema": {
                "type": "binary"
              },
              "description": "File content (PDF or Markdown)"
            }
          }
        },
        "responses": {}
      }
    },
    "/documents": {
      "delete": {
        "summary": "DELETE /documents",
        "tags": [
          "Documents"
        ],
        "parameters": [],
        "responses": {}
      }
    },
    "/collections": {
      "get": {
        "summary": "GET /collections",
        "tags": [
          "Collections"
        ],
        "parameters": [],
        "responses": {
          "200": {
            "description": "Successful operation",
            "content": {
              "application/json": {
                "schema": {
                  "type": "object"
                }
              }
            }
          },
          "400": {
            "description": "Bad request",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/Error"
                }
              }
            }
          },
          "500": {
            "description": "Internal server error",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/Error"
                }
              }
            }
          }
        }
      }
    },
    "/chunks": {
      "delete": {
        "summary": "DELETE /chunks",
        "tags": [
          "Chunks"
        ],
        "parameters": [],
        "responses": {}
      }
    },
    "/chat": {
      "post": {
        "summary": "Chat with AI using RAG",
        "description": "Send a query to the AI system and receive a response augmented with relevant document knowledge",
        "tags": [
          "Chat"
        ],
        "parameters": [],
        "requestBody": {
          "required": true,
          "content": {
            "application/json": {
              "schema": {
                "type": "object"
              },
              "description": "Request body containing query and configuration"
            }
          }
        },
        "responses": {}
      }
    },
    "/jobs/{jobId}": {
      "get": {
        "summary": "GET /jobs/{jobId}",
        "tags": [
          "Jobs"
        ],
        "parameters": [],
        "responses": {
          "200": {
            "description": "Successful operation",
            "content": {
              "application/json": {
                "schema": {
                  "type": "object"
                }
              }
            }
          },
          "400": {
            "description": "Bad request",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/Error"
                }
              }
            }
          },
          "500": {
            "description": "Internal server error",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/Error"
                }
              }
            }
          }
        }
      }
    },
    "/documents/{documentId}": {
      "delete": {
        "summary": "DELETE /documents/{documentId}",
        "tags": [
          "Documents"
        ],
        "parameters": [],
        "responses": {
          "200": {
            "description": "Successful operation",
            "content": {
              "application/json": {
                "schema": {
                  "type": "object"
                }
              }
            }
          },
          "400": {
            "description": "Bad request",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/Error"
                }
              }
            }
          },
          "500": {
            "description": "Internal server error",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/Error"
                }
              }
            }
          }
        }
      }
    },
    "/jobs/{jobId}/resume": {
      "post": {
        "summary": "POST /jobs/{jobId}/resume",
        "tags": [
          "Jobs"
        ],
        "parameters": [],
        "responses": {}
      }
    }
  },
  "tags": [
    {
      "name": "Chat",
      "description": "Chat API endpoints"
    },
    {
      "name": "Chunks",
      "description": "Chunks API endpoints"
    },
    {
      "name": "Collections",
      "description": "Collections API endpoints"
    },
    {
      "name": "Documents",
      "description": "Documents API endpoints"
    },
    {
      "name": "Files",
      "description": "Files API endpoints"
    },
    {
      "name": "Jobs",
      "description": "Jobs API endpoints"
    },
    {
      "name": "Openapi",
      "description": "Openapi API endpoints"
    },
    {
      "name": "Postman",
      "description": "Postman API endpoints"
    },
    {
      "name": "Retrieval",
      "description": "Retrieval API endpoints"
    },
    {
      "name": "Webpages",
      "description": "Webpages API endpoints"
    }
  ],
  "components": {
    "schemas": {
      "Error": {
        "type": "object",
        "properties": {
          "error": {
            "type": "string"
          },
          "details": {
            "type": "string"
          }
        }
      }
    }
  }
} as const;
